export default __webpack_public_path__ + "264b76488c9d64d20740382b49d5090e.png";